import { TabsType } from 'components/Tabs/Tabs';
import { Translation } from 'hooks/useTranslation/useTranslation';

export const createUsersTabs = (translation: Translation, isEntraLess: boolean): TabsType[] => [
  {
    text: isEntraLess ? translation.users : translation.external_groups,
    location: '/users/external-groups'
  },
  {
    text: translation.installers,
    location: '/users/Installers'
  }
];
